if (typeof PickupAvailabilityExtended !== 'function') {
  class PickupAvailabilityExtended extends HTMLElement {
    constructor() {
      super();
      // console.log('Constructor: Initializing component');
      this.classList.add('active');
      this.fetchAvailability(this.dataset.variantId, this.dataset.variantIsbn);
      // this.setupEventListeners();
    }

    fetchAvailability(variantId, isbn) {
      if (!variantId || !isbn) {
        console.error('fetchAvailability: Missing variantId or isbn', { variantId, isbn });
        this.renderError();
        return;
      }
      // console.log('fetchAvailability: Fetching availability for Variant ID:', variantId, 'ISBN:', isbn);
      this.getBNAvailability(null, variantId, isbn);
    }

    getBNAvailability(position, variantId, isbn) {
      console.log('getBNAvailability: Getting BN availability for Variant ID:', variantId, 'ISBN:', isbn, 'Position:', position);
      var lat = "";
      var lon = "";
      if (position != null) {
        lat = position.coords.latitude;
        lon = position.coords.longitude;
      }

      console.log('Latitude:', lat, 'Longitude:', lon);

      const data = { lat, lon, isbn };

      let rootUrl = this.dataset.baseUrl;
      if (!rootUrl.endsWith("/")) {
        rootUrl += "/";
      }
      const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=helper-pickup-availability-extended`;

      // console.log('getBNAvailability: Fetching Shopify section from URL:', variantSectionUrl);

      fetch(variantSectionUrl)
        .then(response => response.text())
        .then(text => {
          // console.log('getBNAvailability: Refreshed section');
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('.shopify-section');
          if (sectionInnerHTML) {
            this.renderPreview(sectionInnerHTML, data);
          } else {
            console.error('getBNAvailability: shopify-section is null');
          }
        })
        .catch(e => {
          console.error('getBNAvailability: ERROR RENDERING SHOPIFY SECTION', e);
          const button = this.querySelector('button');
          if (button) button.removeEventListener('click', this.onClickRefreshList);
          this.renderError();
        });
    }

    soh(data) {
      if (!data) {
        console.warn('soh: WARNING - SoH data is blank or invalid. This needs to be handled in pickup-availabilities.js');
        return;
      }

      const button = this.querySelector('button');
      
      if (button) button.addEventListener('click', (evt) => {
        const drawer = document.querySelector('pickup-availability-drawer');
        if (drawer) drawer.show(evt.target);
      });

      const store_array = data;
      const locations_arr = store_array.filter(store => store.store); // Ensure only stores with valid 'store' property are included

      console.log('soh: Locations array:', locations_arr);

      const locations_list_items = document.getElementsByClassName("pickup-availability-list__item");

      // console.log('soh: Location list items:', locations_list_items);

      const items = Array.prototype.slice.call(locations_list_items);

      // console.log('soh: Items before sorting:', items);

      items.sort((a, b) => {
        return locations_arr.findIndex(l => l.store === a.id) - locations_arr.findIndex(l => l.store === b.id);
      });

      const available_locations = [];
      const unavailable_locations = [];

      for (let i = 0, len = items.length; i < len; i++) {
        const parent = items[i].parentNode;
        const detachedItem = parent.removeChild(items[i]);

        if (locations_arr.findIndex(l => l.store === detachedItem.id) >= 0) {
          detachedItem.classList.remove("hidden");
          available_locations.push(detachedItem);
          parent.appendChild(detachedItem);
        } else {
          detachedItem.classList.add("hidden");
          unavailable_locations.push(detachedItem);
          parent.appendChild(detachedItem);
        }
      }

      this.setupEventListeners();  

      // console.log('soh: Available locations:', available_locations);
      // console.log('soh: Unavailable locations:', unavailable_locations);
      
      const headerText = this.querySelector('span.pickup-availability-widget__header-text');
      const headerAlert = this.querySelector('span.pickup-availability-widget__header-alert');

      if (available_locations.length > 0) {
        
        if (button) {
          const addButtonText = button.querySelector('span.reserve-collect-btn-text');
          if (addButtonText) {
            // console.log('soh: Setting textContent and removing hidden class from reserveIcon');
            addButtonText.innerHTML = "Find in-store &rarr;";
            button.removeAttribute('disabled');
          } else {
            console.error('soh: addButtonText is null', { addButtonText });
          }
          
          headerAlert.classList.remove("alert--error");
          headerAlert.classList.remove("alert--blank");
          headerAlert.classList.add("alert--success");
          headerText.textContent = "Available in-store";
          
        }
        this.classList.remove("hidden");
      } else {
        if (button) {
          const addButtonText = button.querySelector('span.reserve-collect-btn-text');
          // console.log('soh: Button structure for unavailable case:', button.outerHTML);
          if (addButtonText) {
            // console.log('soh: Setting textContent and removing hidden class from reserveIcon for unavailable case');
            addButtonText.textContent = "Unavailable in-store";
            button.setAttribute('disabled', 'disabled');
          } else {
            console.error('soh: addButtonText or reserveIcon is null for unavailable case', { addButtonText, reserveIcon });
          }
          headerText.textContent = "Unavailable in-store";
          headerAlert.classList.remove("alert--success");
          headerAlert.classList.remove("alert--blank");
          headerAlert.classList.add("alert--error");
        }
      }
    }

    onClickRefreshList(evt) {
      console.log('onClickRefreshList: Refresh list clicked');
      this.fetchAvailability(this.dataset.variantId, this.dataset.variantIsbn);
    }

    renderError() {
      console.error('renderError: RENDERING ERROR');
      this.innerHTML = '';
      if (this.errorHtml) {
        this.appendChild(this.errorHtml);
      } else {
        console.error('renderError: errorHtml is not defined');
      }
      const button = this.querySelector('button');
      if (button) {
        button.addEventListener('click', this.onClickRefreshList.bind(this));
      }
      this.classList.remove("hidden");
    }

    renderPreview(sectionInnerHTML, data) {
      // console.log('renderPreview: Rendering preview');
      const availabilityWidget = sectionInnerHTML.querySelector('#PickupAvailabilityWidget');
      if (availabilityWidget) {
        this.innerHTML = availabilityWidget.innerHTML;
        this.querySelectorAll('.pickup-availability-widget__location-view').forEach(elm => {
          elm.addEventListener('click', () => {
            const targetElement = document.getElementById(`${elm.getAttribute('aria-controls')}`);
            if (targetElement) {
              targetElement.classList.toggle('opened');
              elm.setAttribute('aria-selected', elm.getAttribute('aria-selected') === "true" ? "false" : "true");
            } else {
              console.error('renderPreview: targetElement is null for aria-controls:', elm.getAttribute('aria-controls'));
            }
          });
        });
      

        const url = new URL("https://3lb5xgt6k2yjymli2kgha74bhu0jzzwh.lambda-url.ap-southeast-2.on.aws");
        Object.entries(data).forEach(([key, value]) => {
          url.searchParams.append(key, value);
        });

        // console.log('renderPreview: Fetching data from URL:', url);

        fetch(url)
          .then(response => response.json())
          .then(data => this.soh(data))
          .catch(e => {
            console.error('renderPreview: Error fetching BW data:', e);
            const button = this.querySelector('button');
            if (button) button.removeEventListener('click', this.onClickRefreshList);
            this.renderError();
          });
      } else {
        console.error('renderPreview: Error in availability fetch, availabilityWidget is null');
      }

      const availabilitySidebar = sectionInnerHTML.querySelector('#PickupAvailabilitySidebar');
      if (availabilitySidebar) {
        const existingSidebar = document.querySelector('sidebar-drawer#site-availability-sidebar');
        if (existingSidebar) {
          existingSidebar.remove();
        }
        const sidebarElement = availabilitySidebar.querySelector('#site-availability-sidebar');
        if (sidebarElement) {
          document.body.appendChild(sidebarElement);
          const moreButton = document.querySelector('.pickup-availability-widget__more');
          if (moreButton) {
            moreButton.addEventListener('click', e => {
              e.preventDefault();
              const sidebar = document.getElementById('site-availability-sidebar');
              if (sidebar) {
                sidebar.show();
              } else {
                console.error('renderPreview: sidebar is null for id site-availability-sidebar');
              }
            });
          } else {
            console.error('renderPreview: moreButton is null for .pickup-availability-widget__more');
          }
        } else {
          console.error('renderPreview: sidebarElement is null for #site-availability-sidebar');
        }
      } else {
        console.error('renderPreview: availabilitySidebar is null for #PickupAvailabilitySidebar');
      }
    }

    setupEventListeners() {
      
        const drawerContentWrapper = document.getElementById('drawer-content-wrapper');
        const siteAvailabilitySidebar = document.getElementById('site-availability-sidebar');
        const storeList = document.getElementById('store-list');
        const reservationForm = document.getElementById('reservation-form');
        const backButton = document.getElementById('back-button');
        const resetReservationFormButton = document.getElementById('cancel-button');
        const form = document.getElementById('reserve-and-collect-form');
        const submitButton = document.getElementById('submit-button');
        const formError = document.getElementById('form-error');
        const formErrorText = document.getElementById('form-error-text');
        const formSuccess = document.getElementById('form-success');

        function showForm(store, product) {
          document.getElementById('store-name-hidden').value = store.shop_name;
          const storeNameLabels = document.getElementsByClassName('reservation-store-name-label');
          for (let i = 0; i < storeNameLabels.length; i++) {
            storeNameLabels[i].textContent = store.shop_name;
          }

          const storeNameWithAddressLabels = document.getElementsByClassName('reservation-store-name-with-address-label');
          for (let i = 0; i < storeNameWithAddressLabels.length; i++) {
            storeNameWithAddressLabels[i].textContent = store.shop_name + ", " + store.shop_address;
          }

          document.getElementById('store-email').value = store.reservation_email;
          document.getElementById('product-price').value = product.price;
          document.getElementById('product-available').value = product.available;
          document.getElementById('product-title').value = product.title;
          document.getElementById('product-author').value = product.vendor;
          document.getElementById('product-isbn').value = product.sku;
        
          // Show the form
          reservationForm.classList.remove('hidden');
          formSuccess.classList.add('hidden');
          formSuccess.classList.remove('alert');
          formError.classList.add('hidden');
          formError.classList.remove('alert');
          form.classList.remove('hidden');
        
          // Trigger a reflow to ensure the transition happens
          void drawerContentWrapper.offsetWidth;

        
          drawerContentWrapper.classList.add('show-form');
          addRequiredAttributes();
          initializeCaptcha();
        }

        function addRequiredAttributes() {
          document.getElementById('text-1659500283612-0').setAttribute('required', '');
          document.getElementById('text-1659501153836-0').setAttribute('required', '');
          document.getElementById('text-1659501209267-0').setAttribute('required', '');
        }
        
        function removeRequiredAttributes() {
          document.getElementById('text-1659500283612-0').removeAttribute('required', '');
          document.getElementById('text-1659501153836-0').removeAttribute('required', '');
          document.getElementById('text-1659501209267-0').removeAttribute('required', '');
        }

        function initializeCaptcha() {
          const hCaptchaDiv = document.querySelector('.hcaptcha');
          if (hCaptchaDiv) {
            hCaptchaDiv.innerHTML = '';
            const script = document.createElement('script');
            script.src = "https://mymesa.site/forms/hcaptcha.js";
            script.async = true;
            script.defer = true;
            hCaptchaDiv.appendChild(script);
          }
        }
        
      
        function showStoreList() {
          removeRequiredAttributes();
          drawerContentWrapper.classList.remove('show-form');

          // // Restore the previous scroll position of the store list
          // const storeList = document.getElementById('store-list');
          document.activeElement.blur();
          setTimeout(() => {
            document.activeElement.blur();
          }, 10);
          // siteAvailabilitySidebar.scrollTop = storeListScrollPosition;
          
        }

        function resetReservationForm() {
          form.reset();
          document.activeElement.blur();
          // Blur the active element to ensure no field is focused
          setTimeout(() => {
            document.activeElement.blur();
          }, 10);
        }
      
        document.querySelectorAll('.reserve-button').forEach(button => {
          button.addEventListener('click', function() {
            console.log(this.getAttribute('data-store'))
            console.log(this.getAttribute('data-product'))
            const store = JSON.parse(this.getAttribute('data-store'));
            const product = JSON.parse(this.getAttribute('data-product'));
            
            showForm(store, product);
          });
        });
      
        backButton.addEventListener('click', function(e) {
          e.preventDefault(); // Prevent the form submission
          showStoreList();
        });

        resetReservationFormButton.addEventListener('click', function(e) {
          e.preventDefault(); // Prevent the form submission
          showStoreList();
          resetReservationForm();
        });

        form.addEventListener('submit', function(e) {
          e.preventDefault();
        
          submitButton.setAttribute('aria-disabled', true);
          submitButton.textContent = "Sending";
        
          const formData = new FormData(form);
          const hCaptchaResponse = document.querySelector('.hcaptcha textarea[name="h-captcha-response"]').value;
        
          // Check if hCaptcha is completed
          if (!hCaptchaResponse) {
            formError.classList.remove('hidden');
            formError.classList.add('alert');
            formErrorText.textContent = "Please complete the captcha.";
            submitButton.removeAttribute('aria-disabled');
            submitButton.textContent = "Reserve";
            return;
          }
        
          const data = {
            'text-1659500283612-0': formData.get('text-1659500283612-0'),
            'text-1659501153836-0': formData.get('text-1659501153836-0'),
            'text-1659501209267-0': formData.get('text-1659501209267-0'),
            'h-captcha-response': hCaptchaResponse,
            storeName: formData.get('store-name'),
            storeEmail: formData.get('store-email'),
            price: formData.get('product-price'),
            availableOnline: formData.get('product-available'),
            productTitle: formData.get('product-title'),
            productAuthor: formData.get('product-author'),
            productISBN: formData.get('product-isbn'),
          };
        
          fetch("https://mymesa.site/hh-bookseller/forms/new_workflow_1_1.json", {
            method: 'post',
            body: JSON.stringify(data),
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            }
          }).then(response => {
            if (response.ok) {
              formSuccess.classList.remove('hidden');
              formSuccess.classList.add('alert');
              formError.classList.add('hidden');
              formError.classList.remove('alert');;
              submitButton.textContent = "Sent!";
              form.classList.add('hidden');
              setTimeout(showStoreList, 10000);
            } else {
              return response.json().then(errorData => {
                let errorMessage = 'Form submission failed';
                if (errorData && errorData.error && errorData.error.message) {
                  errorMessage = errorData.error.message;
                }
                throw new Error(errorMessage);
              });
            }
          }).catch((error) => {
            formError.classList.remove('hidden');
            formError.classList.add('alert');
            formErrorText.textContent = `Submission failed: ${error.message || 'An unknown error occurred.'}`;
            submitButton.removeAttribute('aria-disabled');
            submitButton.textContent = "Reserve";
          });
        });
        
        function checkCaptchaCompletion() {
          const hCaptchaResponseElement = document.querySelector('.hcaptcha textarea[name="h-captcha-response"]');
          if (hCaptchaResponseElement) {
            const hCaptchaResponse = hCaptchaResponseElement.value;
            if (hCaptchaResponse) {
              formError.classList.add('hidden');
              formError.classList.remove('alert');
            } else {
              setTimeout(checkCaptchaCompletion, 500); // Check every 500ms
            }
          } else {
            // If the hCaptcha element is not found, retry after a short delay
            setTimeout(checkCaptchaCompletion, 500); // Check every 500ms
          }
        }
        
        // Start polling for captcha completion
        checkCaptchaCompletion();
        
      
        // Close the drawer when clicking outside of it
        window.addEventListener('click', function(event) {
          if (event.target === drawerContentWrapper.parentElement) {
            drawerContentWrapper.classList.remove('show-form');
            form.reset();
            formSuccess.classList.add('hidden');
            formSuccess.classList.remove('alert');
            formError.classList.add('hidden');
            formError.classList.remove('alert');
            submitButton.textContent = "Reserve";
            submitButton.removeAttribute('aria-disabled');
          }
        });

    }
  }

  if (typeof customElements.get('pickup-availability-extended') === 'undefined') {
    customElements.define('pickup-availability-extended', PickupAvailabilityExtended);
  }
}
